import React from 'react';
import { Link } from 'react-router-dom';
import Icono from './Icono';
import { enlaceWhatsApp } from '../config/contacto';

// Piezas que se repiten en varias páginas. Viven juntas porque son chicas y
// porque así cualquier cambio de diseño en una se ve en todas a la vez.

/**
 * Migas de pan de las páginas interiores. `items` = [{ label, to? }], el
 * último es la página actual (sin enlace, con aria-current).
 */
export function Migas({ items }) {
  return (
    <nav className="migas" aria-label="Ruta de navegación">
      <ol>
        <li>
          <Link to="/">Inicio</Link>
        </li>
        {items.map((it, i) =>
          i === items.length - 1 || !it.to ? (
            <li key={it.label}>
              <span aria-current="page">{it.label}</span>
            </li>
          ) : (
            <li key={it.label}>
              <Link to={it.to}>{it.label}</Link>
            </li>
          )
        )}
      </ol>
    </nav>
  );
}

/** Cabecera oscura de páginas interiores: migas, título y entrada. */
export function CabeceraInterior({ migas, titulo, entrada, children }) {
  return (
    <section className="cabecera-interior zona-oscura">
      <div className="contenedor">
        {migas && <Migas items={migas} />}
        <h1>{titulo}</h1>
        {entrada && <p className="cabecera-interior__entrada">{entrada}</p>}
        {children}
      </div>
    </section>
  );
}

/** Botón de WhatsApp con mensaje precargado. */
export function BotonWhatsApp({ mensaje, children = 'Hablemos por WhatsApp', variante = 'primario' }) {
  return (
    <a
      className={`btn btn--${variante}`}
      href={enlaceWhatsApp(mensaje)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Icono nombre="chat" />
      {children}
      <span className="solo-lector"> (abre WhatsApp en otra pestaña)</span>
    </a>
  );
}

/** Banda final de llamada a la acción, igual en todas las páginas. */
export function CtaFinal({
  titulo = 'Cuéntenos qué le está quitando tiempo.',
  texto = 'Escríbanos por WhatsApp o déjenos un mensaje. La primera conversación es para entender su caso y no tiene costo.',
  mensaje,
}) {
  return (
    <section className="seccion zona-oscura cta-final" aria-labelledby="cta-final-titulo">
      <div className="contenedor cta-final__caja">
        <div>
          <h2 id="cta-final-titulo">{titulo}</h2>
          <p>{texto}</p>
        </div>
        <div className="grupo-botones">
          <BotonWhatsApp mensaje={mensaje} />
          <Link className="btn btn--secundario" to="/contacto">
            Escribir un mensaje
          </Link>
        </div>
      </div>
    </section>
  );
}

/** Preguntas frecuentes con <details>: funcionan sin JavaScript y con teclado. */
export function Preguntas({ items }) {
  return (
    <div className="faq">
      {items.map((p) => (
        <details key={p.pregunta}>
          <summary>
            {p.pregunta}
            <Icono nombre="mas" />
          </summary>
          <div className="faq__respuesta">
            <p>{p.respuesta}</p>
          </div>
        </details>
      ))}
    </div>
  );
}
